import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Her rota için tarayıcı sekmesinde görünecek başlık.
// Mevcut çeviri anahtarları yeniden kullanılır, yeni metin gerekmez.
const TITLE_KEYS = {
  "/urunler": "products",
  "/about": "subMenus.corporate.about",
  "/iletisim": "contactNavbar",
  "/stores": "storesFooter",
  "/sss": "faq.title",
  "/kurumsal/kalite-politikamiz": "qualityPolicy.title",
  "/bayilikler": "dealershipsPage.title",
  "/hesaplayicilar": "calc.eyebrow",
};

const PageTitle = () => {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const siteName = t("siteName");

    // Ürün, kategori ve marka sayfaları başlığı kendileri koyar
    if (["/urun/", "/urunler/", "/marka/", "/markalar", "/karsilastir", "/toptan-teklif", "/teklif-listesi", "/yeni/", "/rehber"].some((p) => pathname.startsWith(p))) return;

    if (pathname === "/") {
      document.title = siteName;
      return;
    }

    // Tam eşleşme yoksa en uzun ön ek ile eşleştir (ör. /urunler/kategori/alt)
    const match =
      TITLE_KEYS[pathname] ||
      TITLE_KEYS[
        Object.keys(TITLE_KEYS)
          .filter((p) => pathname.startsWith(p))
          .sort((a, b) => b.length - a.length)[0]
      ];

    const pageName = match ? t(match).trim() : "";
    document.title = pageName ? `${pageName} — ${siteName}` : siteName;
  }, [pathname, t, i18n.language]);

  return null;
};

export default PageTitle;
